export default "__VITE_ASSET__BzFPIAhc__"